import { Component, ElementRef, ViewChild } from '@angular/core';
import {FormBuilder, Validators, FormsModule, ReactiveFormsModule,FormControl, FormArray, AbstractControl, FormGroup} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatStepperModule} from '@angular/material/stepper';
import {MatButtonModule} from '@angular/material/button';
import { DatePipe } from '@angular/common';
import { Router ,ActivatedRoute} from '@angular/router';
import {SettingsService} from '../../services/settings.service';
import { FlightService } from 'src/app/services/flight.service';
import { City, Country, State, StaticdataService } from 'src/app/services/staticdata.service';
import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/internal/operators/map';
import { startWith } from 'rxjs/internal/operators/startWith';
import { CustomValidatorsService } from 'src/app/services/custom-validators.service';
import { UserprofileService } from 'src/app/services/userprofile.service';
import { UserInfo, UserInfoService } from 'src/app/services/user-info.service';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import {C, COMMA, ENTER} from '@angular/cdk/keycodes';
import { DataService } from 'src/app/services/data.service';
import { Location } from '@angular/common';
import {CarrierCodeService} from '../../services/carrier-code.service';
import {AirConfigService}  from 'src/app/services/air-config.service'
import { PageEvent } from '@angular/material/paginator';
import {ReportingConfigService} from 'src/app/services/reporting-config.service'
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import { HotelService } from 'src/app/services/hotel.service';
import { UserService } from 'src/app/services/user.service';
import * as moment from 'moment';

import { DialogService } from 'src/app/util/dialog/dialog.service';
import { concat } from 'rxjs';
@Component({
  selector: 'app-hotel-booking',
  templateUrl: './hotel-booking.component.html',
  styleUrls: ['./hotel-booking.component.css']
})
export class HotelBookingComponent {
  days: number[] = Array.from({ length: 31 }, (_, i) => i + 1);
  months = [
  { value: '1', label: 'JAN' },
  { value: '2', label: 'FEB' },
  { value: '3', label: 'MAR' },
  { value: '4', label: 'APR' },
  { value: '5', label: 'MAY' },
  { value: '6', label: 'JUN' },
  { value: '7', label: 'JUL' },
  { value: '8', label: 'AUG' },
  { value: '9', label: 'SEP' },
  { value: '10', label: 'OCT' },
  { value: '11', label: 'NOV' },
  { value: '12', label: 'DEC' }
];
carrierCode = []

  fetchPassengerDetails:any
  years =Array.from({ length: 12 }, (_, i) => new Date().getFullYear() - i);
  infentsYears =Array.from({ length: 2 }, (_, i) => new Date().getFullYear() - i);
  @ViewChild('travellerInput') travellerInput!: ElementRef<HTMLInputElement>;
  traveller = new FormControl('');
  filteredTo!: Observable<any[]>;
  commercialFee:any
totalCommercialAmount:any=0
rules:any={
  InputPaxInfo:false
}
flightSeatMapping:any=[]

  separatorKeysCodesTo: number[] = [ENTER, COMMA];
  travellerTo:any=[]
  travellerName:any
  rows: string[] = ['A', 'B', 'C', 'D','E','F'];
  seats: number[]=[]
  // allSeats :any= Array.from({ length: 29 }, (_, index) => (index + 1).toString());
  allSeats :any=[];

  selectedSeats: string[]=[]
  usersList:any;
  repriceData:any=[]
  fare:any={
    totalPrice:0,
    totalTax:0
     }
  employeeData:any;
  userUid:any
  domIn:any={
    international:false,
    domestic:false
  }
  aisleSeats: string[] = [];
  flightList:any
  firstFormGroup = this._formBuilder.group({
    firstCtrl: ['', Validators.required],
  });
  secondFormGroup = this._formBuilder.group({
    "passengerDetails":this.fb.array([
     
    ]),
    "passengerChild":this.fb.array([
     
    ]),
    "passengerInfent":this.fb.array([
      
    ]),
    "BillingEntity":['', Validators.required]
  });
  get passengerDetails(){
    return this.secondFormGroup.get('passengerDetails') as FormArray;
  }
  get passengerChild(){
    return this.secondFormGroup.get('passengerChild') as FormArray;
  }
  get passengerInfent(){
    return this.secondFormGroup.get('passengerInfent') as FormArray;
  }
  secondNextFormGroup = this._formBuilder.group({
    specialRequest: [[]],
    otherRequest: [''],
    earlyCheckin:[''],
    lateCheckOut:[''],



  });
  
  showOthersField:boolean = false;
  showEarlyCheckin:boolean = false;
  showLateCheckOut:boolean = false;
  showSpinners = true;        // Show spinners for time input
  showSeconds = true;         // Allow seconds input
  stepHour = 1;               // Hour step
  stepMinute = 1;             // Minute step
  stepSecond = 1;             // Second step
  touchUi = false;            // Show in touch UI mode
  color: 'primary' | 'accent' | 'warn' = 'primary'; // Date picker color
  enableMeridian = false;      // 12-hour format (AM/PM)
  disableMinute = false;      // Enable/disable minute input
  hideTime = false;           // Hide time portion of the picker
  onSpecialRequestChange(event: any): void {
    const selectedValues = event.value;

    // Check if 'Others' is selected
    this.showOthersField = selectedValues.includes('Others');
    this.showEarlyCheckin=selectedValues.includes('Early Check in');
    this.showLateCheckOut=selectedValues.includes('Late check out');
    // Clear the 'otherRequest' field if 'Others' is not selected
    if (!this.showOthersField) {
      this.secondNextFormGroup.get('otherRequest')?.setValue('');
    }
    if (!this.showEarlyCheckin) {
      this.secondNextFormGroup.get('earlyCheckin')?.setValue('');
    }
    if (!this.showLateCheckOut) {
      this.secondNextFormGroup.get('lateCheckOut')?.setValue('');
    }
    
  }
  thirdFormGroup = this._formBuilder.group({
    mobileCtrl: ['', [Validators.required,Validators.pattern("^[\\+]{0,1}[0-9\\s]{10,14}$")]],
    emailCtrl: ['', [Validators.required,Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)]],

  });
  fourthFormGroup = this._formBuilder.group({
    fourthCtrl: ['', Validators.required],
  });
  isLinear = false;
flights:any
returnFlights:any
returnLastFlight:any
lastflight:any
thirdFlights:any
thirdLastFlight:any
fourthFlights:any
fourthLastFlight:any
userType:any
travellerDetail:any={}
addressCountryFormControl! : FormControl; 
pnrNo:any
userUuid:any
countryFilteredOptions: Observable<Country[]>|undefined;
seatPagination:any
searchDetail:any
hotelDetail:any
source:any=""
loginUserType:any=''
  constructor(private UserService:UserService,private DialogService:DialogService,private location:Location,private order:DataService,private userInfoService : UserInfoService,private DataEntityService:ReportingConfigService,
    private _formBuilder: FormBuilder,private route:ActivatedRoute,private CarrierCodeService:CarrierCodeService,
    private  SettingsService:SettingsService,private FlightService:FlightService,private staticDataService : StaticdataService,
    private customValidator : CustomValidatorsService,private fb : FormBuilder,private userProfileService:UserprofileService,
    private AirConfigService:AirConfigService, private toastMsgService : ToastmsgService,
    private HotelService:HotelService
    ) {
      this.ENABLE_TRIP_MGMT()
      this.userType=userInfoService.getUserType();
      this.userType=this.userType.toUpperCase()
      this.userUuid=this.userInfoService.getUserUuid()
      this.dataEntitylist()
      this.reportingTags()
      this.loginUserType=sessionStorage.getItem('loginUserType')
this.loginUserType=this.loginUserType.toUpperCase()

      if(this.userType==='AGENT'){
        // this.billingDetail?.entityName
        this.secondFormGroup.patchValue({
          BillingEntity: 'N/A'
        });
      }

      this.carrierCode=this.CarrierCodeService.carrierCode()
      this.rulesPriv()
    


  }
  travellerS:any
  getReportingTagsControls(passenger: AbstractControl): AbstractControl[] {
    const reportingTags = passenger.get('reportingTags') as FormArray;
    return reportingTags ? reportingTags.controls : [];
  }

  onItineraryClick(){
    this.firstFormGroup = this.fb.group({
      firstCtrl: ['first', Validators.required],
    });
    if(this.userType==='CORPORATE'){
      this.getCorporateUsers();
      this.onfilterChange(this.fetchPassengerDetails)
    }else if(this.userType==='EMPLOYEE'){
      
      this.getEmployeeData();
      
    }
  }
  _filterCountry(countryName: string): Country[] {
    return this.staticDataService.countryCache.filter(option =>
      option.countryName.toLowerCase().indexOf(countryName.toLowerCase()) === 0);
  }
  displayCountrySelectionFn(country : Country) {
    return country ? country.countryName : "";
  }
  dateFormate(date:any){
    // date=this.convertToISOStringFormat(date)
    const parsedDate = new Date(date);
    const datePipe = new DatePipe('en-IN');
    date = datePipe.transform(parsedDate, 'EEE dd MMM yyyy');
    // date = datePipe.transform(parsedDate, 'EEE dd MMM yyyy');

return date

  }

  convertToISOStringFormat(dateString:any) {
    // Remove the ' 00:00' part and then add 'Z' at the end
    const isoDateString = dateString.replace('00.000 00:00', '00.000Z');
    return isoDateString;
  }
timeFormate(date:any){
    // date=this.convertToISOStringFormat(date)
    const parsedDate = new Date(date);
    const datePipe = new DatePipe('en-IN');
    date = datePipe.transform(parsedDate, 'hh:mma');
    // date = datePipe.transform(parsedDate, 'EEE dd MMM yyyy');

return date

  }
  isSeatSelected(row: string, seat: number): boolean {
    
    return this.selectedSeats?.includes(row + seat);
  }

  isAisle(row: string, seat: number): boolean {
    
    return this.aisleSeats?.includes(row + seat);
  }
  toggleSeat(row: string, seat: number): void {

    const seatIdentifier = row + seat;
  

    if (this.selectedSeats?.includes(seatIdentifier)) {
      this.selectedSeats = this.selectedSeats.filter(
        (selectedSeat) => selectedSeat !== seatIdentifier

        
      );
   
     
    } else {
      if (this.selectedSeats.length <this.flightMealDetails.length) {
        this.selectedSeats.push(seatIdentifier);
       
for (let i = 0; i < this.flightMealDetails.length; i++) {
  // Directly access the flightDetailsList for readability
  let flightDetailsList = this.flightMealDetails[i].flight.flightDetailsList;
  // Find the first item that matches the fromAirport condition
  
  let itemToUpdate = flightDetailsList.find((item:any) => item.fromAirport === this.flightSeatMapping.fromAirport);
if(itemToUpdate===undefined){
   flightDetailsList = this.flightMealDetails[i].returnFlights.flightDetailsList;

  itemToUpdate = flightDetailsList.find((item:any) => item.fromAirport === this.flightSeatMapping.fromAirport);

  if(itemToUpdate===undefined){
    flightDetailsList = this.flightMealDetails[i].thirdFlights.flightDetailsList;
 
   itemToUpdate = flightDetailsList.find((item:any) => item.fromAirport === this.flightSeatMapping.fromAirport);

   if(itemToUpdate===undefined){
    flightDetailsList = this.flightMealDetails[i].fourthFlights.flightDetailsList;
 
   itemToUpdate = flightDetailsList.find((item:any) => item.fromAirport === this.flightSeatMapping.fromAirport);
 }
 }


}

  // If an item is found and there's a corresponding selectedSeat, update the seat
  if (itemToUpdate && this.selectedSeats[i]) {
    itemToUpdate.seat = this.selectedSeats[i];
    if(this.unitKeyData.length>0){
      if(this.unitKeyData[0].unitKey){
    itemToUpdate.unitKey = this.unitKeyData.filter((key:any)=>key.seat===itemToUpdate.seat)[0].unitKey}}
  }

  
}


        
              
      

        
      } else {
        // Handle the case where the user tries to select more than three seats
        console.log("You can only select up to "+this.flightMealDetails.length+" seats.");
      }
      // this.selectedSeats.push(seatIdentifier);
    }
this.fourthFormGroup = this._formBuilder.group({
  fourthCtrl: [this.selectedSeats.toString(), Validators.required],
});
  }
  isrequired(row: string, seat: number): boolean {
    
    return this.selectedSeats?.includes(row + seat);
  }
  
  converter(item:any){
    const totalMinutes = item ;
    const hours = Math.floor(totalMinutes / 60);
    const remainingMinutes = totalMinutes % 60;
    item=`${hours}h ${remainingMinutes}m`
    return item
  }
  fligthNameFilter(item:any){
  if(item){
  let flightName:any=[]
  flightName=this.carrierCode.filter((itm: { carrierCode: any; })=>itm.carrierCode === item)
  if(flightName.length===0){
   return item
 
 }else{
   flightName =flightName[0].flightName
   return flightName
 }}else{
  return item
 }
  }
  cityFilter(item:any){
    

    if(item && this.flightList){
     
  
      item=this.flightList.filter((itm: { iataCode: any; })=>itm.iataCode === item)
  
    item=item[0]?.city
  
  return item}else{
    return item
  }
  }
  airPortFilter(item:any){
    
    if(item && this.flightList){
    item=this.flightList.filter((itm: { iataCode: any; })=>itm.iataCode === item)
  
  item=item[0]?.name
  return item}else{
    return item
  }
  }
 
  getFlightList(){
   
    this.FlightService
    .getFlightList()
    .subscribe({
      next : (res:any) => {
        if(res) {
         let data:any
         data=res  
         this.flightList=data
     
        } else {    
        } 
      },error : (err) => {

        
      }
    }
  )
  }
  onCheckboxChange(event: any) {
    if (event.checked) {
      this.acknowledge=false
      // Add your logic here for when the checkbox is checked
    } else {
      this.acknowledge=true

      // Add your logic here for when the checkbox is unchecked
    }
  }
  acknowledge:boolean=false
  flightMealDetails:any
  travellerDetails:any=[]

  RequiredPopup(){
    
    if(this.passengerDetails.invalid||this.passengerChild.invalid||!this.secondFormGroup.value.BillingEntity){
      let adultData:any=this.getInvalidFields(this.passengerDetails)
      let childData:any=this.getInvalidFields(this.passengerChild)
    
    let adult:any = adultData.map((item:any) => `Adult ${item.passengerIndex + 1}: ${item.invalidFields.join(', ')}`).join('\n')
    let child:any =childData.map((item:any) => `Child ${item.passengerIndex + 1}: ${item.invalidFields.join(', ')}`).join('\n')
    let billingEntity=''
    if(this.secondFormGroup.value.BillingEntity){
      billingEntity=''
    }else{
      billingEntity='billingEntity'
    
    }
    let allData = [adult, child, billingEntity].filter(Boolean).join('\n');
    this.DialogService.open({msg : allData,title : "Warning (Required Fields is missing)",buttonType : "Ok"})
           
        this.DialogService.onResponse((response :  string) => {
         
          if(response=="Ok") {
    
    
          }})}
    
      }
      getInvalidFields(item:any) {
        return item.controls.map((group:any, index:any) => {
          const invalidFields = Object.keys((group as FormGroup).controls)
            .filter(field => (group as FormGroup).get(field)?.invalid);
          
          return invalidFields.length > 0 ? { passengerIndex: index, invalidFields } : null;
        }).filter((entry:any) => entry !== null);
      }
  PassengerDetails(){

    this.secondFormGroup.value.passengerDetails?.forEach((item:any,i:number)=>{

      item.username=item.email
      if(i===0){
        this.thirdFormGroup =this.fb.group({
          mobileCtrl: [item?.mobile, [Validators.required,Validators.pattern("^[\\+]{0,1}[0-9\\s]{10,14}$")]],
          emailCtrl: [item?.email, [Validators.required,Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)]],
      
        });}
     }) 

   let  merged_passengerDetails:any=[]
   merged_passengerDetails=merged_passengerDetails.concat(this.secondFormGroup.value.passengerDetails,this.secondFormGroup.value.passengerChild)
   this.travellerDetails=merged_passengerDetails
   console.log(this.travellerDetails)
   this.mapRoomsToGuests()
// console.log(this.flightMealDetails)
  }

  mergedData:any = [];

  
  mapRoomsToGuests() {
    this.mergedData=[]
    let travellerIndex = 0;
    // const assignedPassengers = new Set();

let rooms:any=[]



const assignedPassengers = new Set<string>();

// Function to create a unique key for a passenger
function getPassengerKey(passenger: any) {
  return `${passenger.passengerTitle}-${passenger.firstName}-${passenger.lastName}`;
}
rooms=[...this.searchDetail.rooms]

rooms.forEach((room:any) => {
  // Get unassigned adults (ADT) by checking the unique key
  const adults = this.travellerDetails
    .filter((passenger:any) => 
      passenger.passengerType === 'ADT' && 
      !assignedPassengers.has(getPassengerKey(passenger))
    )
    .slice(0, room.adults); // Limit to the room's adult capacity

  // Mark adults as assigned using the unique key
  adults.forEach((adult:any) => assignedPassengers.add(getPassengerKey(adult)));

  // Get unassigned children (CHD) and limit based on room's childrenAges length
  const children = this.travellerDetails
    .filter((passenger:any) => 
      passenger.passengerType === 'CHD' && 
      !assignedPassengers.has(getPassengerKey(passenger))
    )
    .slice(0, room.childrenAges.length); // Limit to the number of children allowed by room

  // Mark children as assigned using the unique key
  children.forEach((child:any) => assignedPassengers.add(getPassengerKey(child)));

  // Update room with assigned passengers
  room.assignedAdults = adults.map((adult:any) => `${adult?.passengerTitle} ${adult?.firstName} ${adult?.lastName}`);
  room.assignedChildren = children.map((child:any, index:number) => ({
    name: `${child?.passengerTitle} ${child?.firstName} ${child?.lastName}`,
    age: room.childrenAges[index] // Match age to the child
  }));
if(this.seatPagination?.selectedHotelOrder?.hotel?.mmtRooms)
{
  const roomData:any = {
    roomType: this.seatPagination?.selectedHotelOrder?.hotel?.mmtRooms[0]?.name || 'N/A',
    mealPlan: this.seatPagination?.selectedHotelOrder?.hotel?.mmtRooms[0]?.ratePlans[0]?.description || 'N/A',
    guests: room
  };

  this.mergedData.push(roomData)
}else if(this.seatPagination?.selectedHotelOrder?.hotel?.expediaRooms){
  const roomData:any = {
            roomType: this.seatPagination?.selectedHotelOrder?.hotel?.expediaRooms[0]?.room_name || 'N/A',
            mealPlan: this.seatPagination?.selectedHotelOrder?.hotel?.expediaRooms[0]?.rates[0]?.description || 'N/A',
            guests: room
          };
        
          this.mergedData.push(roomData)
        }

});
  }
  




paymentDetail:boolean=false
backClick(){
  this.paymentDetail=false



}

  bookflight(){
    console.log("-----")
    this.advancedPricingDataList.forEach((item:any)=>{
      item.advancedPricingList=item.advancedPricingList.filter((item:any) => item !== null)
    })
let traveller:any=[]

this.travellerDetails.forEach((item:any)=>{
  let data:any={
           "lastName": item.lastName,
            "title": item?.passengerTitle,
            "firstName": item?.firstName,
            "isdCode": "91",
            "emailId": item.email,
            "mobileNo":  item.mobile,
            "masterPax": true,
            "paxType": item.passengerType==="ADT"?("ADULT"):'CHILD',
            "gender": item?.passengerTitle==='MR'?('MALE'):'FEMALE'
  }
  traveller.push(data)
})
    console.log(this.travellerDetails)
   let data:any={}

//    [
//     {
//         "lastName": "Tester",
//         "title": "Mr",
//         "firstName": "Test",
//         "isdCode": "91",
//         "emailId": "dh@gmail.com",
//         "mobileNo": "9873457812",
//         "masterPax": true,
//         "paxType": "ADULT",
//         "gender": "MALE"
//     }
// ]
   
// "paxCount": this.travellerDetail?.adult+this.travellerDetail?.child+this.travellerDetail?.infantCount,
// "adultCount": this.travellerDetail?.adult,
// "childCount": this.travellerDetail?.child,
// "infantCount": this.travellerDetail?.infantCount,

// "passengerDetails": this.travellerDetails,
// "contactNumber": this.thirdFormGroup?.value?.mobileCtrl,
// "email":this.thirdFormGroup?.value?.emailCtrl,
// "isInternational":  this.domIn.international,
// "isDomestic":this.domIn.domestic,
// "bookedFor":this.userUid,
//   'gstNumber':   this.billingDetail?.entityGST    ,
//   'billingEntity':   this.billingDetail.entityRefId  ,
//    'gstEmail':   this.billingDetail?.email   ,
//    'runtimeMarkUp':this.advancedPricingDataList
// } 
  console.log()
  data={
      "blockId": this.repriceData[0].blockId,
      "currency": "INR",
      "travellers": traveller,
      "gstinNumber": "",
      "gstinCompanyAddress": "",
      "gstinCompanyName": "",
      "panCard": null,
      "specialRequest": "late check in"
  
      
  }
  // "gstinNumber": this.billingDetail?.entityGST,
  //     "gstinCompanyAddress": this.billingDetail?.address,
  //     "gstinCompanyName": this.billingDetail?.gstName,



this.swingOrderId=true
// sessionStorage.setItem('json', JSON.stringify(data));
// sessionStorage.setItem('advancetotal',this.advanceTotal.toString());

this.OrderId(data)
//this.bookingData(data)
  }

  restrictedSeats:any=[]
  chargeableSeats:any=[]
  seatFare:any=[]
  unitKeyData:any=[]
seatMapping(data:any,flightDetailsList:any){
  

  this.FlightService
  .SeatMapping(data,'','')
  .subscribe({
    next : (res:any) => {
      flightDetailsList.showSeatSelection=false

      if(res) {
        let data:any
        data=res

        data.airSeatRows.sort((a:any, b:any) => {
          return a.row - b.row; // Sort in ascending order based on 'row' property
        });


      data.airSeatRows.forEach((row:any)=>{
        this.seats.push(row.row)

        row.airSeats.forEach((column:any)=>{
          if(column.seatCharacteristics){

            let CHARGEABLE_SEAT:any='CHARGEABLE_SEAT'
            let RESTRICTED_SEAT:any='RESTRICTED_SEAT'
            

            if(column.seatCharacteristics?.includes(CHARGEABLE_SEAT)){
              console.log(column.column)
              if(column?.seatOccupancy!='Occupied'){
            this.chargeableSeats.push(column.column+row.row)
              }
            }
            if(column.seatCharacteristics?.includes(RESTRICTED_SEAT)){
              this.restrictedSeats.push(column.column+row.row)
            }
          }
          // if(column.seatCharacteristics){
          //   // console.log(column.column+row.row)
          //   column.seatCharacteristics.forEach((item:any)=>{

          //     if(item.includes('CHARGEABLE_SEAT')){ 
          //       this.chargeableSeats.push(column.column+row.row)

          //                     }
                             
          //                    if(item.includes('RESTRICTED_SEAT')){

          //                     this.restrictedSeats.push(column.column+row.row)
            
          //                                  }
              
          //   })
          //       }

          if(column?.seatOccupancy==='Occupied'){
            this.aisleSeats.push(column.column+row.row)
          }
          if(column?.seatOccupancy==='Available'){
            this.seatFare.push({seat:column.column+row.row,price:column?.baseFare})

            // this.seatFare.push({seat:column.column+row.row,price:column?.baseFare+column?.finalTax})
          }

          

            if(column.unitKey){
         this.unitKeyData.push({seat:column.column+row.row,unitKey:column.unitKey})
          }
          

})
        
      })
    
if(this.seats.length!=0){
  this.seatPopup=true

}else{
  this.seatPopup=true

  this.seats=this.allSeats.slice(0, 29);
}
     
      } else {    
        this.seatPopup=true

  this.seats=this.allSeats.slice(0, 29);
      } 
    },error : (err) => {
      // this.seatPopup=true
      this.toastMsgService.setMsg({msg : "Seats is not available",msgTitle : "Warning", msgType : "W"});

      // this.seats=this.allSeats.slice(0, 29);
      flightDetailsList.showSeatSelection=false

    }
  }
)

}


isRestricted(column:any,row:any){
  let boolean:boolean=false

  if(this.restrictedSeats.length>0){
    this.restrictedSeats.forEach((item:any):any=>{

      if(item==column+row){
        boolean=true

      }})
  
}

return boolean

}
isChargeable(column:any,row:any){
  let boolean:boolean=false

  if(this.chargeableSeats.length>0){
    this.chargeableSeats.forEach((item:any):any=>{

      if(item==column+row){
        boolean=true

      }})
}

return boolean

}

popoverSeatPrice(column:any,row:any){
  let price:any='N/A'
  if(this.seatFare.length>0){
  this.seatFare.forEach((item:any):any=>{

    if(item.seat==column+row){
      console.log(item.price)
 price= item.price+' INR'||0
    }


  })}
  console.log(price)
    return price
}

  getCorporateUsers(){
   
    this.userProfileService
    .getUserList()
    .subscribe({
      next : (res:any) => {
        if(res) {
         
         let data:any
         data=res  
         this.usersList=data
        this.usersList=this.usersList.filter((item:any) => item.firstName && item.firstName.trim() !== '');
         this.travellerTo=this.usersList
         this.filteredTo = this.traveller.valueChanges.pipe(
          // debounceTime(300), // Adjust the debounce time as needed
          //distinctUntilChanged(),
          startWith(null),
          map((item: any | null) => (item ? this._filter(item) : this.travellerTo.slice())),
        );

        } else {    
        } 
      },error : (err) => {

        
      }
    }
  )
  }
  onfilterChange(passengerDetails:any){

    for(let i=0;i<passengerDetails?.length;i++){
      
    let data:any
    data=this.travellerTo.filter((item:any) => item.username===passengerDetails[i]?.username)
    this.passengerDetails.controls[i].value.firstName=data[0]?.firstName

    this.passengerDetails.controls[i].value.lastName=data[0]?.lastName
    this.passengerDetails.controls[i].value.passengerTitle=data[0]?.title
    this.passengerDetails.controls[i].value.profileType=data[0]?.profileType

    this.passengerDetails.controls[i].value.username=data[0]?.username
    if( this.passengerDetails.controls[i].value.firstName){
this.passengerDetails.setValue(this.passengerDetails.value);
    }
    this.thirdFormGroup =this.fb.group({
      mobileCtrl: [data[0]?.contactNumber, [Validators.required,Validators.pattern("^[\\+]{0,1}[0-9\\s]{10,14}$")]],
      emailCtrl: [data[0]?.username, [Validators.required,Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)]],
  
    });

  }
  }
  onfilterClick(value:any,passengerDetails:any){

    this.travellerInput.nativeElement.value=''

   for(let i=0;i<3;i++){

     
    let data:any
    data=this.travellerTo.filter((item:any) => item.username===value)
    passengerDetails.value.firstName=data[0]?.firstName
    passengerDetails.value.lastName=data[0]?.lastName
    passengerDetails.value.passengerTitle=data[0]?.title
    passengerDetails.value.profileType=data[0]?.profileType
    passengerDetails.value.profileId=data[0]?.bookingProfileUuid||""
    passengerDetails.value.username=data[0].username
    passengerDetails.value.email=data[0].username
    passengerDetails.value.mobile=data[0].contactNumber
// if(passengerDetails.value.reportingTags.value.tagDisplayName.split().join().includes(':')){
  // console.log(passengerDetails.value.reportingTags)
  passengerDetails.value.reportingTags.forEach((item:any)=>{

    // console.log(item)
    if(item.tagFixedValue?.startsWith(':')){
    if(item.checkValue){
    if(data[0].hasOwnProperty(item.checkValue)){
      item.value=data[0][item.checkValue]?? data[0].reportingDetails?.[item.checkValue] ??''
    }

    }}
  })
  
  //  this.passengerDetails.controls[0].value.firstName=data[0]?.firstName

  //   this.passengerDetails.controls[0].value.lastName=data[0]?.lastName
  //   this.passengerDetails.controls[0].value.passengerTitle=data[0]?.title
    this.thirdFormGroup.value.emailCtrl=data[0].username
    this.userUid=data[0].userUid
    this.thirdFormGroup =this.fb.group({
      mobileCtrl: [data[0].contactNumber, [Validators.required,Validators.pattern("^[\\+]{0,1}[0-9\\s]{10,14}$")]],
      emailCtrl: [data[0].username, [Validators.required,Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)]],
  
    });
        this.passengerDetails.setValue(this.passengerDetails.value);

   }
   }

  selectedTo(event: MatAutocompleteSelectedEvent): void {

    this.travellerName=event.option.viewValue;

    this.travellerInput.nativeElement.value = event.option.viewValue;
  
    
     
    this.traveller.setValue(null);
  
  }
  getEmployeeData(){

    this.userProfileService
    .getEmployeeUser()
    .subscribe({
      next : (res:any) => {
        if(res) {

         let data:any
         data=res  
         this.employeeData=data
         this.passengerDetails.controls[0].value.firstName=this.employeeData?.firstName

         this.passengerDetails.controls[0].value.lastName=this.employeeData?.lastName

         this.passengerDetails.controls[0].value.passengerTitle=this.employeeData?.title
         this.passengerDetails.controls[0].value.username=this.employeeData?.username
         this.passengerDetails.controls[0].value.profileType=this.employeeData?.profileType
         this.passengerDetails.controls[0].value.profileId=this.employeeData?.bookingProfileUuid||""

         this.passengerDetails.controls[0].value.reportingTags.forEach((item:any)=>{

          // console.log(item)
          if(item.tagFixedValue?.startsWith(':')){
        if(item.checkValue){
          if(this.employeeData.hasOwnProperty(item.checkValue)!=null){
            item.value=this.employeeData[item.checkValue] ?? this.employeeData.reportingDetails?.[item.checkValue] ?? ''
          }}}
        
          
        })

for(let i=0;i<this.passengerDetails.value.length;i++){

  this.passengerDetails.controls[i].value.username=this.employeeData?.username
}

         this.passengerDetails.setValue(this.passengerDetails.value);


         this.userUid=this.employeeData?.userUid

         
         this.thirdFormGroup =this.fb.group({
          mobileCtrl: ['', [Validators.required,Validators.pattern("^[\\+]{0,1}[0-9\\s]{10,14}$")]],
          emailCtrl: [this.employeeData?.username, [Validators.required,Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)]],
      
        });
        if(this.employeeData.billingEntity){
          let entityData:any
          entityData=this.DataEntity.filter((entity:any)=>entity.entityRefId===this.employeeData.billingEntity)
          this.addBillingEntity(entityData[0]) 
        }else{
          if(this.DataEntity.length===1){
            this.addBillingEntity(this.DataEntity[0]) 

          }
        }
        

        } else {    
          
        } 
      },error : (err) => {

        
      }
    }

  )

  }
  addTo(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    // Add our fruit
    if (value) {
      this.travellerName.push(value);
    }

    // Clear the input value
    event.chipInput!.clear();

    this.traveller.setValue(null);
  }
  private _filter(value: any): any[] {
   // console.log(value)
    const filterValue = value.toLowerCase();
   
    return this.travellerTo.filter((item:any) => item.username.toLowerCase()?.includes(filterValue));
  }
 

  getrepriceData(response:any){
   
  this.swingGenerate=false
  this.onItineraryClick()


//   if(this.fetchPassengerDetails.length>0){
//     if(this.pnrNo){
//       this.paymentDetail=true
//       this.showSideBar=true
//   let orderId={
//     orderNumber:"",
//     pnr:""
//   }
//   orderId.pnr=this.pnrNo
//   orderId.orderNumber=response.orderId
//       this.order.deliverMsg(orderId)
//   this.swingGenerate=false
//      }else{

//       let json:any = sessionStorage.getItem('json');
//       this.advanceTotal =Number(sessionStorage.getItem('advancetotal'));
//       // console.log(response?.billingEntity)
//        this.billingDetail.entityRefId=response?.billingEntity
// this.OrderId(JSON.parse(json))
 
//   // this.paymentDetail=true
//   this.swingGenerate=false

// }
//  }
  }
  hideAdvancePricing:boolean=true
  flightArray:any=[]
  orderId:any
swingGenerate:boolean=false
swingOrderId:boolean=false

  // generateOrder(data:any){

  //   if(this.returnFlights){
  //     data.bookingRequest.selectedFlight[0].source=this.flights?.source
  //     data.bookingRequest.selectedFlight[1].source=this.returnFlights?.source

  //   }else{
  //     data.bookingRequest.selectedFlight[0].source=this.flights?.source

  //   }
  //   this.FlightService
  //   .generateOrder(data)
  //   .subscribe({
  //     next : (res:any) => {
  //       this.swingGenerate=false

  //       if(res) {
  //         console.log(data)
  //         this.repriceData=data?.bookingRequest?.selectedFlight
  //        let item:any
  //        item=res  
  //        this.orderId=item
        
  //       

  //       } else {    
  //       } 
  //     },error : (err) => {

       

  //     }
  //   }
  // )
  // }
  bookSuccess:any=[]
  printObject(obj: any):void {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        this.bookSuccess.push(`${key}: ${obj[key]}`)
      }else{
        

      }
    }
  }
  checkDate(date:any){
    if(date){
    // date=this.convertToISOStringFormat(date)
    const parsedDate = new Date(date);
    const datePipe = new DatePipe('en-IN');
    date = datePipe.transform(parsedDate, 'dd-MMM-yyyy HH:mm:ss');
    // date = datePipe.transform(parsedDate, 'EEE dd MMM yyyy');
    }
return date

  }
  orderboolean:any
  orderIds(){
    this.acknowledge=true    // this.paymentDetail=true
    this.swingOrderId=true
    this.orderboolean=true
   
    let specialRequest: string[] = this.secondNextFormGroup?.value?.specialRequest || [];
    let otherRequest: string = this.secondNextFormGroup?.value?.otherRequest || '';
    let checkInTime:string=this.checkDate(this.secondNextFormGroup?.value?.earlyCheckin)  || '';
    let checkOutTime:string=this.checkDate(this.secondNextFormGroup?.value?.lateCheckOut) || '';
    let special: any = specialRequest
      .map((item: string) => (item === 'Others' ? 'Others-'+otherRequest : item));    
     let special2:any= special.map((item: string) => (item === 'Early Check in' ? checkInTime?('Early Check in ( Check in request time - '+checkInTime):'' : item))
     let special3:any= special2.map((item: string) => (item === 'Late check out' ? checkOutTime?('Late check out ( Check out request time - '+checkOutTime):'' : item)).join(',');
     let markUp:any={...this.repriceData[0].commercial}
     markUp.markup=this.advancedPricingDataList[0].advancedPricingList[0].baseAmt||0
    //  this.advancedPricingDataList=[{advancedPricingList:[ {feeAmt: 0, baseAmt:this.repriceData[0].commercial.markup||0, taxAmt: 0 }]}]

    let data={
      "hotelBookingRequest": {
      "paxCount": this.travellerDetail?.adult+this.travellerDetail?.child+this.travellerDetail?.infantCount,
      "adultCount": this.travellerDetail?.adult,
      "childCount": this.travellerDetail?.child,
      "infantCount": '',
      // //"prefAirSource": this.flights?.source,
      // //"selectedFlight":this.repriceData,
      "rmApprovalUpload":this.rmApprovalUpload,
      "passengerDetails": this.travellerDetails,
      "contactNumber": this.thirdFormGroup?.value?.mobileCtrl,
      "email":this.thirdFormGroup?.value?.emailCtrl,
      "specialRequest":special3,
      "isInternational":  this.domIn.international,
      "isDomestic":this.domIn.domestic,
      "bookedFor":this.userUid,
      'gstNumber':   this.billingDetail?.entityGST,
      'billingEntity':   this.billingDetail.entityRefId,
       'gstEmail':   this.billingDetail?.email,
       'runtimeMarkUp':markUp
    } }
   
    let d:any={
      "orderNumber": "STG220724190707505",
      "paymentConfig": {
          "userUid": "133",
          "product": "AIR",
          "status": [
              {
                  "mediumName": "DEPOSIT",
                  "isBusinessEnabled": true,
                  "isPersonalEnabled": false
              },
              {
                  "mediumName": "CREDIT",
                  "isBusinessEnabled": false,
                  "isPersonalEnabled": false
              },
              {
                  "mediumName": "VIRTUAL_CARD",
                  "isBusinessEnabled": false,
                  "isPersonalEnabled": false
              }
          ]
      },
      "priceData": {
          "totalBookingAmount": 5257,
          "totalBaseAmount": 4506,
          "airlineTaxes": 751,
          "commissionData": {
              "finalAmount": 0,
              "Fee": {
                  "product": "AIR",
                  "type": null,
                  "label": "Fee",
                  "tag": null,
                  "currency": null,
                  "value": 0,
                  "totalValue": 0,
                  "taxes": [
                      {
                          "label": "GST",
                          "name": "GST",
                          "hsnCode": "998559",
                          "percent": 18,
                          "currency": null,
                          "amount": 0
                      }
                  ]
              }
          },
          "markupData": null,
          "miscPriceData": null,
          "mealCharges": 0,
          "seatCharges": 0,
          "preferenceCharges": null,
          "insurance": null,
          "currency": null
      },
      "passThroughInfo": null
  }



  

// this.commercialData()




this.OrderId(data)

  }
  OrderId(item:any){
    
    this.swingOrderId=true

    this.HotelService
    .OrderId(item,this.orderId)
    .subscribe({
      next : (res:any) => {
        this.acknowledge=false
        this.swingOrderId=false
        if(res) {
          this.paymentDetail=true

         let data:any
         data=res  
         data.hotelBookingRequest=item
         data.searchDetail=this.searchDetail
data.hotelDetail=this.hotelDetail 
data.orderUId=this.orderId
data.repriceData=this.seatPagination
data.travellerDetails=this.travellerDetails
         this.order.deliverMsg(data)

         this.orderboolean=true
        //  this.paymentDetail=true
         this.printObject(data[0])
         
        //  this.DialogService.open({msg :"Booking Id: "+data?.bookingId+"\n Status: "+data?.status,title : "Confirmation",buttonType : "tag"})
       
        //  this.DialogService.onResponse((response :  string) => {
          
        //    if(response=="Back to Search Page") {
           
        //     window.close();

 
        //    }})
          data.entityRefId=this.billingDetail?.entityRefId
          this.hideAdvancePricing=false

        //  this.order.deliverMsg(data)

        } else {    
        } 
      },error : (err) => {
        this.acknowledge=false

        this.toastMsgService.setMsg({msg : "Failed to book hotel",msgTitle : "Warning", msgType : "W"});

        this.swingOrderId=false

        // this.paymentDetail=true
// let datas:any={}
// datas.searchDetail=this.searchDetail
// datas.hotelDetail=this.hotelDetail 
// datas.orderUId=this.orderId
// datas.repriceData=this.seatPagination
// datas.travellerDetails=this.travellerDetails
//          this.order.deliverMsg(datas)

      }
    }
  )
  
  }
  
  expandedPanel: string | null = 'totalPrice';
  
  togglePanel(panel: string): void {
    this.expandedPanel = this.expandedPanel === panel ? null : panel;
  }
  rmTagsCopy() {
    const sourceGroup = this.passengerDetails.at(0) as FormGroup;
    const sourceTags = sourceGroup.get('reportingTags') as FormArray;
  
    for (let i = 1; i < this.passengerDetails.length; i++) {
      const targetGroup = this.passengerDetails.at(i) as FormGroup;
      const targetTags = targetGroup.get('reportingTags') as FormArray;
  
      // Ensure source and target arrays are same length
      for (let j = 0; j < sourceTags.length; j++) {
        const sourceValue = sourceTags.at(j).value?.value || '';
        if (targetTags.length > j) {
          targetTags.at(j).patchValue({ value: sourceValue });
        }
      }
    }
  }
  
  rmTagsFileTypeCopy() {
    const sourceGroup = this.passengerDetails.at(0) as FormGroup;
    const sourceTags = sourceGroup.get('reportingTags') as FormArray;
  
    for (let i = 1; i < this.passengerDetails.length; i++) {
  
      const targetGroup = this.passengerDetails.at(i) as FormGroup;
      const targetTags = targetGroup.get('reportingTags') as FormArray;
  
      // Ensure source and target arrays are same length
      for (let j = 0; j < sourceTags.length; j++) {
        console.log(sourceTags)
        const sourceValue = sourceTags.at(j).value?.value || '';
        if(sourceTags.at(j).value?.fieldType==='F'){
        if (targetTags.length > j) {
          targetTags.at(j).patchValue({ value: sourceValue });
        }}
      }
    }
  }

  getObjectKeysAndValues(obj: any): { key: string, value: any }[] {
    // console.log(this.departureFlight)
    // let flight:any=this.departureFlight
   
    if(obj){
  

      let object:any=[]
       object=Object.entries(obj).map(([key, value]) => ({ key, value }));
       let hiddenKeys: any="bookingAmount,currency"
    object=object.filter((item:any)=>!hiddenKeys?.includes(item.key))

   
    return object;
   }else{
    return obj
   }
  }

  changeKey(item:any){
    if(item==='totalAmount'){
      let traveller=(Number(this.travellerDetail?.adult)+Number(this.travellerDetail?.child)+Number(this.travellerDetail?.infantCount))
      if(traveller>1){
        item="Base fare ("+traveller+" travellers)"

      }else if(item==="airlineTaxes"){
        item="Taxes and fees"


      }
     else{
        item="Base fare ("+traveller+" traveller)"

      }
      return item
    }else{
    return  item
    }
  }
  showSideBar:boolean=false
  hideSideBar(){
    console.log('34gf4')
   this.showSideBar=true
  }



  commercialData(){
    this.orderboolean=true
    this.FlightService
    .CommercialBooking(this.orderId)
    .subscribe({
      next : (res:any) => {
        if(res) {
         let data:any
         data=res  
         this.totalCommercialAmount=data?.finalAmount

         this.commercialFee=this.getObjectKeysAndValues(data)
         
        
        this.commercialFee=this.commercialFee.filter((item:any)=>item.key!='finalAmount')
          
        } else {    
        } 
      },error : (err) => {


      }
    }
  )
  
  }
  rulesPriv(){

    this.FlightService
    .rules()
    .subscribe({
      next : (res:any) => {
        if(res) {
          let data:any
         data=res
          this.rules.InputPaxInfo=data.InputPaxInfo
        } else {    
        } 
      },error : (err) => {


      }
    }
  )
  
  }
 
  flightlogoFilter(item:any){
  
    if(item){
       let flightName:any=[]
    flightName=this.carrierCode.filter((itm: { carrierCode: any; })=>itm.carrierCode === item)
    
    if(flightName.length===0){
     return item
   
   }else{
     flightName =flightName[0]?.logo
     return flightName
   }
    }else{return item}
   }
page:any={
  page:0
}
   totalElements:number=0
   nextPage(event:PageEvent) {
   
    this.page['page'] = event.pageIndex.toString();
    // page['size'] = event.pageSize.toString();
    this.flightSeatMapping=this.flights?.flightDetailsList[this.page.page]
  //  this.openSeat()
  
  }

  DataEntity:any=[]
  dataEntitylist(){

    this.DataEntityService
   .listEntities(this.userUuid)
   .subscribe({
      next : (res:any) => {
        if(res) {
       let data=res
       this.DataEntity=data
       this.filterEntities()

        } else {
       
        } 
      },error : (err) => {

    }
    }
  )
 }
 reportingData:any=[]
 reportingTags(){
this.swingGenerate=true

  this.DataEntityService
 .tagPAX(this.userUuid)
 .subscribe({
    next : (res:any) => {
      if(res) {
     let data=res
     this.reportingData=data['body']


     this.route.queryParams.subscribe(params => {
  let data:any
  data=params
  // console.log(data)
if(data?.id){
this.orderId=this.SettingsService.decodeTransformed(data?.id)
}
// this.commercialData()
this.swingGenerate=true


// let searchDetail=JSON.parse(data.searchDetail)
// this.hotelDetail=JSON.parse(data.hotelDetail)
// this.searchDetail=searchDetail

this.HotelService.hotelreprice(this.orderId)
  .subscribe({
    next : (res:any) => {
   
      if(res) {
      
       let response:any
       response=res
        if(response.bookingId){
          this.hideSideBar()
          this.paymentDetail=true

          let request:any
          request=res  
 request.orderUId=request.orderId
 request.bookingId=response.bookingId
          this.order.deliverMsg(request)
        }
    
       let searchDetail=response
       let hotelDetail:any={"name":response?.selectedHotelOrder?.hotel?.name,
       "starRating":response?.selectedHotelOrder?.hotel?.ratings[0].starRating,
       "location":response?.selectedHotelOrder?.hotel?.address,
       "pinCode":response.selectedHotelOrder?.hotel?.pinCode}

      this.hotelDetail=hotelDetail
        this.searchDetail=response?.hotelRequest
        // console.log(this.searchDetail)
        if(response?.selectedHotelOrder?.hotel?.mmtRooms){
          
          this.repriceData=response?.selectedHotelOrder?.hotel?.mmtRooms[0]?.ratePlans
          this.source='mmt'
          this.advanceTotal=this.repriceData[0]?.commercial?.markup||0

        }else if(response?.selectedHotelOrder?.hotel?.expediaRooms){
          this.source='expedia'

          this.repriceData=response?.selectedHotelOrder?.hotel?.expediaRooms[0]?.rates
          this.advanceTotal=this.repriceData[0]?.commercial?.markup||0
        }
this.initializeAdvancedPricingDataList()
       this.seatPagination=response
       
      //  this.fetchPassengerDetails=searchDetail?.searchDetail
      // console.log(searchDetail)

      this.travellerDetail.adult=this.searchDetail?.adultCount
      this.travellerDetail.child=this.searchDetail?.childCount
      // console.log(this.travellerDetail)

      this.pnrNo=response?.pnr
  
      

      // this.userType=userInfoService.getUserType();
      // this.userType=this.userType.toUpperCase()
   //   console.log(this.userType)
    
   



    if(response.tag){
      this.DialogService.open({msg : "",title : "Confirmation",buttonType : "Ok"})
       
        this.DialogService.onResponse((response :  string) => {
         
          if(response=="OK") {
          


          }})
    }
      this.getFlightList();

 


    this.addressCountryFormControl = new FormControl({countryCode:"",countryName : ""},[Validators.required,this.customValidator.countryValidator()]);

    this.countryFilteredOptions = this.addressCountryFormControl?.valueChanges
  .pipe(
    startWith({} as Country),
    map((country :Country) => country && typeof country === 'object' ? country.countryName : country),
    map((countryName: string) => countryName ? this._filterCountry(countryName) : this.staticDataService?.countryCache.slice())
  );
 

  for(let i=0;i<this.travellerDetail?.adult;i++){


    const reportingTagsGroup:any = this.fb.array([]);
    
    this.reportingData.forEach((tag: any) => {

      
      if(this.loginUserType==='EMPLOYEE'){

        if (tag.tagValue['show to traveller'] === 'Y') {
          if(tag.tagValue['fieldType'] === 'D'){
            let invoiceboolean:boolean=false
            if(tag["print on invoice"]==='Y'){
              invoiceboolean=true
            }
                    const controlValidators = tag.required === 'C' ? [Validators.required] : [];
                    const controlName =  tag?.tagDisplayName||tag?.tagName;
                    const name=tag?.tagName
                    const value = tag.tagFixedValue && tag.tagFixedValue.includes(':') ? tag.tagFixedValue.split(':')[1] : tag.tagFixedValue;
            
                    const reportingTagGroup = this.fb.group({
                      displayName:[controlName],
                      name: [name],
                      value: ['', controlValidators],
                      invoiceable: [invoiceboolean],
                      required:tag.required,
                      checkValue:[value],
                      fieldType:tag.tagValue['fieldType']
                    });
                    reportingTagsGroup.push(reportingTagGroup);
  
  
          }else{
          let invoiceboolean:boolean=false
  if(tag["print on invoice"]==='Y'){
    invoiceboolean=true
  }
          const controlValidators = tag.required === 'C' ? [Validators.required] : [];
          const controlName =  tag?.tagDisplayName||tag?.tagName;
          const name=tag?.tagName
          const value = tag.tagFixedValue && tag?.tagFixedValue?.includes(':') ? tag.tagFixedValue.split(':')[1] : tag.tagFixedValue;
  
          const reportingTagGroup = this.fb.group({
            displayName:[controlName],
            name: [name],
            value: [tag?.tagFixedValue?.startsWith(':') ? '' : value, controlValidators],
            tagFixedValue:[tag?.tagFixedValue],
            invoiceable: [invoiceboolean],
            required:tag.required,
            checkValue:[value],
            fieldType:tag.tagValue['fieldType']
          });
          reportingTagsGroup.push(reportingTagGroup);
        }}
      }
      else{
        // show to traveller
      if (tag.tagValue['show to admin'] === 'Y') {
        if(tag.tagValue['fieldType'] === 'D'){
          let invoiceboolean:boolean=false
          if(tag["print on invoice"]==='Y'){
            invoiceboolean=true
          }
                  const controlValidators = tag.required === 'C' ? [Validators.required] : [];
                  const controlName =  tag?.tagDisplayName||tag?.tagName;
                  const name=tag?.tagName
                  const value = tag.tagFixedValue && tag.tagFixedValue.includes(':') ? tag.tagFixedValue.split(':')[1] : tag.tagFixedValue;
          
                  const reportingTagGroup = this.fb.group({
                    displayName:[controlName],
                    name: [name],
                    value: ['', controlValidators],
                    invoiceable: [invoiceboolean],
                    required:tag.required,
                    checkValue:[value],
                    fieldType:tag.tagValue['fieldType']
                  });
                  reportingTagsGroup.push(reportingTagGroup);


        }else{
        let invoiceboolean:boolean=false
if(tag["print on invoice"]==='Y'){
  invoiceboolean=true
}
        const controlValidators = tag.required === 'C' ? [Validators.required] : [];
        const controlName =  tag?.tagDisplayName||tag?.tagName;
        const name=tag?.tagName
        const value = tag.tagFixedValue && tag?.tagFixedValue?.includes(':') ? tag.tagFixedValue.split(':')[1] : tag.tagFixedValue;

        const reportingTagGroup = this.fb.group({
          displayName:[controlName],
          name: [name],
          value: [tag?.tagFixedValue?.startsWith(':') ? '' : value, controlValidators],
          tagFixedValue:[tag?.tagFixedValue],
          invoiceable: [invoiceboolean],
          required:tag.required,
          checkValue:[value],
          fieldType:tag.tagValue['fieldType']
        });
        reportingTagsGroup.push(reportingTagGroup);
      }}}
    });
//     this.reportingData.forEach((tag: any) => {
//       if (tag.tagValue['show to admin'] === 'Y') {
//         let invoiceboolean:boolean=false
// if(tag["print on invoice"]==='Y'){
//   invoiceboolean=true
// }
//         const controlValidators = tag.required === 'C' ? [Validators.required] : [];
//         const controlName =  tag?.tagDisplayName||tag?.tagName;
//         const name=tag?.tagName
//         const value = tag.tagFixedValue && tag.tagFixedValue.includes(':') ? tag.tagFixedValue.split(':')[1] : tag.tagFixedValue;

//         const reportingTagGroup = this.fb.group({
//           displayName:[controlName],
//           name: [name],
//           value: [value, controlValidators],
//           invoiceable: [invoiceboolean],
//           required:tag.required,
//           checkValue:[value],
//           fieldType:tag.tagValue['fieldType']
//         });
//         reportingTagsGroup.push(reportingTagGroup);
//       }
//     });
//     this.reportingData.forEach((tag: any) => {
//       if (tag.tagValue['show to admin'] === 'Y') {
//         let invoiceboolean:boolean=false
// if(tag["print on invoice"]==='Y'){
//   invoiceboolean=true
// }
//         const controlValidators = tag.required === 'C' ? [Validators.required] : [];
//         const controlName =  tag?.tagDisplayName;
//         const name=tag?.tagName
//         const value = tag.tagFixedValue?.includes(':') ? tag.tagFixedValue.split(':')[1] : tag.tagFixedValue;

//         const reportingTagGroup = this.fb.group({
//           displayName:[controlName],
//           name: [name],
//           value: [value, controlValidators],
//           invoiceable: [invoiceboolean],
//           required:tag.required,
//           checkValue:[value]

//         });
//         reportingTagsGroup.push(reportingTagGroup);
//       }
//     });
    
    // console.log(reportingTagsGroup.value)
    this.passengerDetails.push(this.fb.group({
        "profileId":[''],
        "firstName":['',[Validators.required]],
        "lastName":['',[Validators.required]],
        "passengerTitle":['',[Validators.required]],
        "passengerType":["ADT",[Validators.required]],
        "username":[""],
        "email":["",[Validators.required,Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)],],
        "profileType":[""],
        "mobile":["",[Validators.required,,Validators.pattern("^[\\+]{0,1}[0-9\\s]{10,14}$")]],
        "reportingTags":reportingTagsGroup
    }))

  }
 
  for(let i=0;i<this.travellerDetail?.child;i++){
    const reportingTagsGroup = this.fb.group({});
    this.reportingData.forEach((tag:any) => {
      if (tag.tagValue['show to admin'] === 'Y') {
        const controlValidators = tag.required === 'C' ? [Validators.required] : [];
        reportingTagsGroup.addControl(tag.tagDisplayName, this.fb.control(tag.tagFixedValue, controlValidators));
      }
    });

    this.passengerChild.push(this.fb.group({
      "firstName":['',[Validators.required]],
        "lastName":["",[Validators.required]],
        "passengerTitle":["",[Validators.required]],
        "passengerType":["CHD",[Validators.required]],
        "email":["",],
        "mobile":["",],

    }))    
      }
   
         


         let traveller=(Number(this.travellerDetail?.adult)+Number(this.travellerDetail?.child))
         if(traveller>1){
          this.travellerS="Guests"
   
         }else{
          this.travellerS="Guest"   
         }

         this.getrepriceData(response);

      
        
        
        } else {    
          
        } 



        },error : (err) => {
        
        
        
        }
        }
        )
            });
      } else {
     
      } 
    },error : (err) => {

  }
  }
)
}
billingDetail:any={
  entityRefId:''
}
 addBillingEntity(item:any){
this.billingDetail=item

this.secondFormGroup.patchValue({
  BillingEntity: this.billingDetail?.entityName
});
this.searchQuery=''
this.filterEntities()

 }
 @ViewChild('tabsRef') tabsRef!: ElementRef;

 tabs = [
  { name: 'Tab 1', active: true },
  { name: 'Tab 2', active: false },
  { name: 'Tab 3', active: false },
  { name: 'Tab 4', active: false },
  { name: 'Tab 5', active: false },
  { name: 'Tab 6', active: false },
  { name: 'Tab 7', active: false },
  { name: 'Tab 8', active: false },
  { name: 'Tab 9', active: false },
  { name: 'Tab 10', active: false }
];
 scrollTabs(direction: 'left' | 'right') {
  const tabsContainer = this.tabsRef.nativeElement;
  const scrollAmount = 200;
  if (direction === 'left') {
    tabsContainer.scrollBy({
      left: -scrollAmount,
      behavior: 'smooth'
    });
  } else if (direction === 'right') {
    tabsContainer.scrollBy({
      left: scrollAmount,
      behavior: 'smooth'
    });
  }
}


fetchMeal(item:any){
  let request:any={}
  request['carrierCode']=item?.carrierName
  request['equipmentType']=item?.equipmentType
  request['travelType']='D'
this.FlightService
  .getMeal(request)
  .subscribe({
    next : (res:any) => {
      if(res) {
        let data:any
        data=res?.body
        
       item.tag=data

      
      } else {  
      } 
    },error : (err) => {


    }
  }
)

}
showSeatSelection:boolean=false
flightItem:any
flightType:any
flightIndex:any
seatWindow(flightDetailsList:any,flight:any,item:any,flightType:any,index:any){
  this.flightIndex=index
this.flightType=flightType
  this.flightItem=item
  this.totalElements=this.flights?.flightDetailsList?.length
  this.flightSeatMapping=flightDetailsList
  flightDetailsList.showSeatSelection=true
  this.seats=[]



  this.openSeat(flightDetailsList,flight)
  this.selectedSeats=[]
}
openSeat(flightDetailsList:any,flight:any){
  this.seats=[]

  let data:any=[]

 
    for(let i=0;i<flight.flightDetailsList.length;i++){
     
     
      
    flight.flightDetailsList[i].bookingClasses=flight.flightDetailsList[i].bookingClasses.filter((item:any)=>item.fareType===flight.fare[0].fareType&&item?.corporateFare === flight.fare[0].corporateFare)
  }
    data={
      
      "paxCount": this.travellerDetail?.adult+this.travellerDetail?.child+this.travellerDetail?.infantCount,
      "adultCount": this.travellerDetail?.adult,
      "childCount": this.travellerDetail?.child,
      "infantCount": this.travellerDetail?.infantCount,
      "selectedFlight": [
            {
              "otherData":flight?.otherData,
               "routeRequest":flight?.routeRequest,
                "source":flight?.routeRequest?.source,
                "fromAirport": flight.flightDetailsList[0].fromAirport,
                "toAirport":  flight.flightDetailsList[flight.flightDetailsList.length - 1].toAirport,
                "flightDetailsList": [flightDetailsList]
  
            }
        ],
    
    } 
  
  
  
  this.seatMapping(data,flightDetailsList)
}
seatPopup:boolean=false
closePopup(){
  this.seatPopup=false
}
showSidebar:boolean=false

travellerArray(item:any){
  // console.log(item)

  let traveller=[]
  if(item){
    // console.log(item)
  for(let i=0;i<1;i++){
    
    traveller.push(i+1)
  }}

   
  return traveller
}
onlyNumberKey(event:any) {
     
  let charCode = (event.which) ? event.which : event.keyCode;
  if (charCode != 46 && charCode > 31
      && (charCode < 48 || charCode > 57))
      return false;
  return true;
}


advancedPricingDataList:any=[]
advanceTotal:number=0
// SubmitAdvancePricing(item:any){
  
// this.total+=Number((item.target as HTMLInputElement).value)
// }
initializeAdvancedPricingDataList() {
  this.advancedPricingDataList=[{advancedPricingList:[ {feeAmt: 0, baseAmt:this.advanceTotal||0, taxAmt: 0 }]}]


       
       
  // this.flightArray.forEach((flightsItem:any) => {
  //   this.advancedPricingDataList.push({
  //     fromAirport: flightsItem.flightDetailsList[0].fromAirport,
  //     toAirport: flightsItem.flightDetailsList[flightsItem.flightDetailsList.length - 1].toAirport,
  //     advancedPricingList: []
  //   });
  // });
}



SubmitAdvancePricing(event: Event, field: string, index: number) {
  let value:any = (event.target as HTMLInputElement).value;
  const pricingData = this.advancedPricingDataList[0].advancedPricingList;
// console.log(this.repriceData[0].commercial.tax)
  if (!pricingData[index]) {
       pricingData[index] = {  feeAmt: 0, baseAmt:this.repriceData[0].commercial.markup||0, taxAmt: 0 };

  //   if(this.source==='mmt')
  //   pricingData[index] = {  feeAmt: 0, baseAmt:this.repriceData[0].commercial.tax||0, taxAmt: 0 };
  // }else if(this.source==='expedia'){
  //   pricingData[index] = {  feeAmt: 0, baseAmt:this.repriceData[0].commercial.tax||0, taxAmt: 0 };

  }
pricingData[index][field] = parseFloat(value||0);


  this.advanceTotal=0
  this.advancedPricingDataList.forEach((item:any)=>{
    item.advancedPricingList.forEach((price:any)=>{
      
      this.advanceTotal+=Number(price.baseAmt)+Number(price.feeAmt)+Number(price.taxAmt)

    })
  })
  
  // console.log(this.advancedPricingDataList)
}
submit(){
  this.showSidebar=false
  
}
OnSidebarClick(){
  this.initializeAdvancedPricingDataList()

  this.showSidebar=true
}


value(item:any){
  console.log(item)
//  return item.value.value
}

starArray(item:any){

  let star=[]
  if(item){
  for(let i=0;i<item;i++){
  star.push(i+1)
  }}

  return star
}
rmApprovalUpload:any
onFileChange(event: any, index: number,con:AbstractControl) {
  const file = event.target.files[0];
  if (file) {
    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = () => {
      // this.getReportingTagsControls()

      const formArray = con.get('reportingTags') as FormArray;
      formArray.value[index].value='NA'
      this.rmApprovalUpload=reader.result
      if(this.rmApprovalUpload){
        this.rmTagsFileTypeCopy()

      }
        // formArray.at(index).patchValue({
        //   value: reader.result
        // });

      };
    reader.onerror = (error) => {
      console.error('Error reading file:', error);
    };
  }
}
tagDropDown(value:any){
  return value.split('|')
}


tripEnable:boolean=false
ENABLE_TRIP_MGMT(){

    this.UserService.ENABLE_TRIP_MGMT()
    .subscribe({
      next : (res:any) => {
        if(res) {
       if(res.policyType==='TRIP_MGMT'){
        if(res.rule==='1'){
          this.tripEnable=true
        }else 
        if(res.rule==='2'){
          this.tripEnable=true
                    }else{
          this.tripEnable=false

        }

       }
 
      }else{

      }},error : (err) => {
  
        console.error("Error in fetching data");
      }
    }
  )
  
}

mmtBaseFare(base:any,couponDiscount:any,hotelDiscount:any){
  let data:any=(base?(base):0)-(couponDiscount?(couponDiscount):0)-(hotelDiscount?(hotelDiscount):0)
return data
}

mapRooms(GuestType: string, i: number): string {
  let rooms = this.searchDetail.rooms;

  if (GuestType === 'ADT') {
    for (let index = 0; index < rooms.length; index++) {
      if (i < rooms[index].adults) {
        return `Room ${index + 1}`;
      }
      i -= rooms[index].adults; // Adjust `i` for the next room
    }
  }

  if (GuestType === 'CHD') {
    for (let index = 0; index < rooms.length; index++) {
      if (i < rooms[index].childrenAges.length) {
        return `${rooms[index].childrenAges[i]} year old - Room ${index + 1}`;
      }
      i -= rooms[index].childrenAges.length; // Adjust `i` for the next room
    }
  }

  return ''; // Default return if no matching room is found
}


searchQuery: any = '';

filteredEntities: any[] = [...this.DataEntity]; // Clone the original data

// Function to filter the entities based on the search query
filterEntities() {

  this.filteredEntities = this.DataEntity.filter((item:any) =>
    item.entityName.toLowerCase().trim().includes(this.searchQuery.toLowerCase().trim())
  );

  
}
onClickSpecialReq(){
let msg:any=`Please note that all special requests are subject to hotel’s approval
and availability .
In case of any confirm / paid request please contact our Customer
Support team and they will check the possibility to accommodate
your special request with hotel.`
    this.DialogService.open({msg : msg,title : "Confirmation",buttonType : "Ok"})
     
      this.DialogService.onResponse((response :  string) => {
       
        if(response=="OK") {
        


        }})
  
}
acceptedTypes = '.jpeg,.jpg,.png,.gif,.pdf,.txt,.eml,.xlsx,.xls,.docx,.csv';
}
